<template>
  <section>
    <notifications></notifications>
    <SupplierProfile
      v-if="'supplier' === getUserRole(sesion)"
      :userId="getUserId(sesion)"
    />
    <ManagerProfile v-else :userId="getUserId(sesion)" />
  </section>
</template>
<script>
// @ is an alias to /src
import { mapGetters } from "vuex";
import SupplierProfile from "./SupplierProfile";
import ManagerProfile from "./ManagerProfile";
export default {
  name: "EditUser",
  data() {
    return {
      userId: ""
    };
  },
  async created() {
    this.getUserRole(this.sesion);
  },
  methods: {
    getUserId(session) {
      return session.id;
    },
    getUserRole(session) {
      if (session.role === session.account_type.type) {
        return session.role;
      } else {
        return session.account_type.type;
      }
    }
  },
  computed: {
    ...mapGetters(["sesion"])
  },
  components: {
    SupplierProfile: SupplierProfile,
    ManagerProfile: ManagerProfile
  }
};
</script>
